var uppercase = {
  filters: {
    uppercase: function (value) {
      return value.trim().toString().toUpperCase();
    },
  },
};

export default uppercase;
